var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('Navbar'),_c('v-card',[_c('v-card-title',[_vm._v(_vm._s(_vm.title))]),_c('v-card-text',[_vm._v(" Verificando Pago, por favor espera... ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }